module.exports = __webpack_public_path__ + "img/35.3bba4683.jpg";